import useReactHookForm from "hooks/useReactHookForm";
import { Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import {
  topicInitialValues,
  topicPropertiesUpdate,
  topicValidationSchema,
} from "./helper";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { useLazyQuery } from "@apollo/client";
import entitesClient from "utils/graphql/entitiesClient";

import { getQueryParam, isEmpty } from "utils/helpers";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { GET_TOPIC_LIST } from "utils/graphql/services/global-content-hierarchy/queries";

export const TopicUpdate = () => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    topicInitialValues,
    topicValidationSchema,
    ""
  );
  const [getTopicList, { loading, error, data }] = useLazyQuery(
    GET_TOPIC_LIST,
    {
      client: entitesClient,
      fetchPolicy: "no-cache",
    }
  );

  const location = useLocation();
  const id = getQueryParam("id", location);
  const status = getQueryParam("status", location);

  useEffect(() => {
    if (!isEmpty(data?.getTopics?.records)) {
      const topic = data?.getTopics?.records?.[0];
      if (!isEmpty(topic)) {
        setValue("global_name", topic?.global_name);
        setValue("gcf_public_topic_id", topic?.gcf_public_topic_id);
        setValue("status", topic?.status);
        setValue("topic_code", topic?.topic_code);
        setValue("image_url", topic?.image_url);
        setValue("gcf_learn_topic_id", topic?.gcf_learn_topic_id);
        setValue("gcf_learn_topic_name", topic?.gcf_learn_topic_name);
        setValue("gcf_public_topic_name", topic?.gcf_public_topic_name);
        setValue("npractice_public_topic_id", topic?.npractice_public_topic_id);
        setValue("npractice_public_topic_name", topic?.npractice_public_topic_name);
        setValue("npractice_practice_topic_id", topic?.npractice_practice_topic_id);
        setValue("npractice_practice_topic_name", topic?.npractice_practice_topic_name);
      }
    }
  }, [data]);

  useEffect(() => {
    getTopicList({
      variables: {
        filter: {
          id:+id,
          status
        },
      },
    });
  }, []);

  if (loading) {
    return <p>loading......</p>;
  }

  return (
    <div>
      <TypographyHeading>Topic</TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={topicPropertiesUpdate}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        </Grid>
      </Paper>
    </div>
  );
};

